export default {
    apiUrl: process.env.REACT_APP_API_URL,
    appDomain: process.env.REACT_APP_APP_DOMAIN,
    quickBooksId: process.env.REACT_APP_QUICKBOOKS_CLIENT_ID
}



// WEBPACK FOOTER //
// ./src/config/config.js